var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"dense":"","text":"","type":"info","icon":"mdi-flask-empty"}},[_vm._v("\n  「分野別ニュース」の関連文献機能は現在ベータ版です。専門家による監修を受けながら項目やコンテンツ等を順次アップデートしております。\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }